<div id="edownload" class="indent">
  <spinner [id]="'downloadspinner'" [show]='activespineer'></spinner>
  <div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-lg-12">
                <h5 class="border-bottom pb-2 mb-2">Excel Download</h5>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                <div class="form-group">
                    <label>Assessment Year</label>
                    <select [(ngModel)]="excelDownloadData['ay']"  class="form-control custom-selectbox">
                        <!-- <option value="">Select Assessment Year</option> -->
                        <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                    </select>
                </div>
                <!-- <span style="color:red" [hidden]="validation[0]">Please Select Assessment Year </span> -->
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
              <div class="form-group">
                  <label>Months Mapping<span class="text-star">*</span></label>
                  <select [(ngModel)]="excelDownloadData['month']"  class="form-control custom-selectbox">
                    <option value="" [disabled]="true">Select start month</option>
                    <option  *ngFor="let month of monthsList"  [value]="month.key">
                      {{month['value']}}</option>
                  </select>
              </div>
              <!-- <span style="color:red" [hidden]="validation[1]">Please Select Month</span> -->
          </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2">
                <div class="form-group">
                    <label>Data Submission</label>
                    <select [(ngModel)]="datasubmitted" disabled="" (change)="dataSubmissionChange()" class="form-control custom-selectbox selectdis">
                      <option value="districtwise" >District Level</option>
                  </select>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                <div class="form-group">
                <label>&nbsp;&nbsp;</label>
                <label>District</label>
                    <select [(ngModel)]="excelDownloadData['lu']" disabled="" class="form-control custom-selectbox selectdis">
                      <option *ngFor="let state of userdetails['loggedUserData']['userProfile']['associatedlocationsDetails']"
                      value="{{state['entityUUID']}}">{{state['entityName']}}</option>
                      </select>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2" style="padding-top: 33px;">
                <button class="btn btn-info pointer" (click)="downloadexcelData()" type="submit" [disabled]='disablesubmit'>Download</button>
            </div>
        </div>
    </div>
  </div>

</div>